import React, { PropsWithChildren } from 'react';
import UnauthorizedPage from '@/components/UnauthorizedPage';
import AuthConsumer from '@/utils/auth';

interface GuardRouteProps {
  permission: string | boolean;
}

/**
 * 路由守卫
 */
const GuardRoute = (props: PropsWithChildren<GuardRouteProps>) => {
  const { authed, permission } = AuthConsumer();

  // 不限制权限或只限制已登录或为超级管理员
  if (!props.permission ||
    props.permission === authed ||
    permission.includes('all')) {
    return <>{props.children}</>;
  }

  // 判断是否含有访问权限
  return (
    <>
      {permission.includes(props.permission as string) ? props.children : <UnauthorizedPage/>}
    </>
  );
};

export default GuardRoute;
